import React from 'react';
import { formatMoney, PAYEE_OPTIONS, peoplePurchases, sumBy, suppliersOfPeriod } from './taxModel';

const cell = 'whitespace-nowrap px-3 py-2 text-sm text-[#D1D5DB]';
const head = 'px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-[#9CA3AF]';
const num = 'whitespace-nowrap px-3 py-2 text-right text-sm tabular-nums text-[#F3F4F6]';

// Who each supplier of the period is: only real suppliers give ITBMS credit; helpers and the owner are paid, not bought from.
export function PeopleTab({ report, onPayeeType }) {
  const suppliers = suppliersOfPeriod(report.purchases);
  const people = peoplePurchases(report.purchases);
  return (
    <div className="space-y-3">
      <p className="text-xs text-[#9CA3AF]">
        Los pagos a ayudantes (servicios profesionales) y al dueño no son compras: no llevan crédito de ITBMS y salen del cálculo, pero quedan
        listados en el anexo impreso para la contadora. Marca aquí a quién se le pagó en cada orden de compra.
      </p>
      {!suppliers.length ? (
        <p className="rounded-lg border border-[#242E42] bg-[#151B26] p-6 text-center text-sm text-[#9CA3AF]">No hay órdenes de compra en este período.</p>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-[#242E42]">
          <table className="w-full min-w-[640px] border-collapse">
            <thead className="bg-[#151B26]"><tr>{['Proveedor / beneficiario', 'Órdenes', 'Total', 'Es…'].map((c) => <th key={c} className={head}>{c}</th>)}</tr></thead>
            <tbody>
              {suppliers.map((entry) => (
                <tr key={entry.supplier_id || entry.supplier_name} className="border-t border-[#242E42]">
                  <td className={cell}>{entry.supplier_name}</td>
                  <td className={num}>{entry.count}</td>
                  <td className={num}>{formatMoney(entry.total)}</td>
                  <td className={cell}>
                    <select
                      aria-label={`Tipo de beneficiario: ${entry.supplier_name}`}
                      value={entry.payee_type}
                      disabled={report.frozen || !entry.supplier_id}
                      onChange={(event) => onPayeeType(entry, event.target.value)}
                      className="h-9 rounded-md border border-[#242E42] bg-[#0B0E14] px-2 text-sm text-[#F3F4F6] disabled:opacity-50"
                    >
                      {PAYEE_OPTIONS.map((option) => <option key={option.id} value={option.id}>{option.label}</option>)}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-[#151B26] font-semibold">
              <tr><td className={cell}>Pagos a ayudantes y dueño ({people.length})</td><td /><td className={num}>{formatMoney(sumBy(people, 'total'))}</td><td /></tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
}
